<div class="search-box" title="Search for an address">
    <i *ngIf="!addressStr && !isSearchFocused" class="glyphicons glyphicons-search"></i>
    <input name="search-box" placeholder="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Locate by place or address" [(ngModel)]="addressStr" (focus)="isSearchFocused=true" (blur)="isSearchFocused=false" (keyup.enter)="searchAddress()">
</div>

<div *ngIf="showAddressList" class="address-list">
    <div *ngFor="let address of addressList" (click)="selectAddressFromList(address)">{{address.addr}}</div>
</div>